import { createMatchSelector } from '@client/selectors/helpers/router';

export const hasBorderSelector = createMatchSelector({
  path: [
    '/for-artists-and-hosts',
    '/for-hosts',
    '/about-us',
    '/messages',
    '/messages/:messageId',
    '/showcalls/create',
    '/showcalls/:callId/edit',
    '/connect/:showCallId',
    '/o/:jwt',
  ],
  exact: true,
});
